import { render, staticRenderFns } from "./error-nologin.vue?vue&type=template&id=797c09f3&scoped=true&"
import script from "./error-nologin.vue?vue&type=script&lang=js&"
export * from "./error-nologin.vue?vue&type=script&lang=js&"
import style0 from "./error-nologin.vue?vue&type=style&index=0&id=797c09f3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797c09f3",
  null
  
)

export default component.exports